// import React, { useState, useEffect } from "react";
// import axios from "axios";

// const Order = () => {
//   const [orders, setOrders] = useState([]); // State to store orders

//   // Fetch orders from the API
//   useEffect(() => {
//     const fetchOrders = async () => {
//       try {
//         const response = await axios.get(
//           "https://ekhoni-khabo-server.vercel.app/api/v1/order/all-orders" // Use the correct endpoint
//         );
//         console.log("API Response:", response.data); // Log the response
//         setOrders(response.data.orders); // Set the orders array from the response
//       } catch (error) {
//         console.error("Error fetching orders:", error);
//       }
//     };
//     fetchOrders();
//   }, []);

//   // Handle delete order
//   const handleDelete = async (orderId) => {
//     const confirmDelete = window.confirm(
//       "Are you sure you want to delete this order?"
//     );
//     if (!confirmDelete) return;

//     try {
//       const token = localStorage.getItem("authToken");
//       await axios.delete(
//         `https://ekhoni-khabo-server.vercel.app/api/v1/order/delete-order/${orderId}`, // Use the correct endpoint
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       // Remove the deleted order from the UI
//       setOrders(orders.filter((order) => order._id !== orderId));
//     } catch (error) {
//       console.error("Error deleting order:", error);
//     }
//   };

//   return (
//     // <div className="p-6 w-full pl-[300px]">
//     //   <h2 className="text-3xl font-bold mb-4">Orders List</h2>
//     //   <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//     //     {orders.map((order) => (
//     //       <div key={order._id} className="bg-white shadow-md rounded-lg p-4">
//     //         <h3 className="text-xl font-semibold">Order ID: {order.orderId}</h3>
//     //         <p className="text-gray-600">Name: {order.name}</p>
//     //         <p className="text-gray-600">Address: {order.address}</p>
//     //         <p className="text-gray-600">Phone: {order.phone}</p>
//     //         <p className="text-gray-600">Email: {order.email}</p>
//     //         <p className="text-gray-600">Request: {order.request}</p>
//     //         <p className="text-gray-600">
//     //           Created At: {new Date(order.createdAt).toLocaleString()}
//     //         </p>
//     //         <button
//     //           onClick={() => handleDelete(order._id)}
//     //           className="mt-4 bg-red-500 text-white py-2 px-4 rounded"
//     //         >
//     //           Delete Order
//     //         </button>
//     //       </div>
//     //     ))}
//     //   </div>
//     // </div>
//     <div className="flex flex-col items-center">
//       <h1 className="text-[30px] font-bold p-4">Orders List</h1>
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pl-64">
//         {orders.map((order) => (
//           <div key={order._id} className="bg-white shadow-md rounded-lg p-4">
//             <h3 className="text-xl font-semibold">Order ID: {order.orderId}</h3>
//             <p className="text-gray-600">Name: {order.name}</p>
//             <p className="text-gray-600">Address: {order.address}</p>
//             <p className="text-gray-600">Phone: {order.phone}</p>
//             <p className="text-gray-600">Email: {order.email}</p>
//             <p className="text-gray-600">Request: {order.request}</p>
//             <p className="text-gray-600">
//               Created At: {new Date(order.createdAt).toLocaleString()}
//             </p>

//             {/* Displaying related items */}
//             <h4 className="text-lg font-semibold mt-3">Items:</h4>
//             <ul className="list-disc ml-4">
//               {order.items && order.items.length > 0 ? (
//                 order.items.map((item) => (
//                   <li key={item._id} className="text-gray-700">
//                     {item.title} - {item.price} Taka
//                   </li>
//                 ))
//               ) : (
//                 <li className="text-gray-500">No items in this order.</li>
//               )}
//             </ul>

//             <button
//               onClick={() => handleDelete(order._id)}
//               className="mt-4 bg-red-500 text-white py-2 px-4 rounded"
//             >
//               Delete Order
//             </button>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Order;

// import React, { useState, useEffect } from "react";
// import axios from "axios";

// const Order = () => {
//   const [orders, setOrders] = useState([]); // State to store orders

//   // Fetch orders from the API
//   useEffect(() => {
//     const fetchOrders = async () => {
//       try {
//         const response = await axios.get(
//           "https://ekhoni-khabo-server.vercel.app/api/v1/order/all-orders" // Use the correct endpoint
//         );
//         console.log("API Response:", response.data); // Log the response
//         setOrders(response.data.orders); // Set the orders array from the response
//       } catch (error) {
//         console.error("Error fetching orders:", error);
//       }
//     };
//     fetchOrders();
//   }, []);

//   // Handle delete order
//   const handleDelete = async (orderId) => {
//     const confirmDelete = window.confirm(
//       "Are you sure you want to delete this order?"
//     );
//     if (!confirmDelete) return;

//     try {
//       const token = localStorage.getItem("authToken");
//       await axios.delete(
//         `https://ekhoni-khabo-server.vercel.app/api/v1/order/delete-order/${orderId}`, // Use the correct endpoint
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       // Remove the deleted order from the UI
//       setOrders(orders.filter((order) => order._id !== orderId));
//     } catch (error) {
//       console.error("Error deleting order:", error);
//     }
//   };

//   return (
//     <div className="flex flex-col items-center">
//       <h1 className="text-[30px] font-bold p-4">Orders List</h1>
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pl-64">
//         {orders.map((order) => (
//           <div key={order._id} className="bg-white shadow-md rounded-lg p-4">
//             <h3 className="text-xl font-semibold">Order ID: {order.orderId}</h3>
//             <p className="text-gray-600">Name: {order.name}</p>
//             <p className="text-gray-600">Address: {order.address}</p>
//             <p className="text-gray-600">Phone: {order.phone}</p>
//             <p className="text-gray-600">Email: {order.email}</p>
//             <p className="text-gray-600">Request: {order.request}</p>
//             <p className="text-gray-600">
//               Created At: {new Date(order.createdAt).toLocaleString()}
//             </p>

//             {/* Displaying related items */}
//             <h4 className="text-lg font-semibold mt-3">Items:</h4>
//             <ul className="list-disc ml-4">
//               {order.items && order.items.length > 0 ? (
//                 order.items.map((item) => (
//                   <li key={item._id} className="text-gray-700">
//                     {item.title} - {item.price} Taka
//                   </li>
//                 ))
//               ) : (
//                 <li className="text-gray-500">
//                   No regular items in this order.
//                 </li>
//               )}
//             </ul>

//             {/* Displaying custom platters and their food items */}
//             <h4 className="text-lg font-semibold mt-3">Custom Platters:</h4>
//             <ul className="list-disc ml-4">
//               {order.customPlatters && order.customPlatters.length > 0 ? (
//                 order.customPlatters.map((platter) => (
//                   <li key={platter._id} className="text-gray-700">
//                     <strong>{platter.platterType}</strong>
//                     <ul className="list-disc ml-4">
//                       {platter.foodItems && platter.foodItems.length > 0 ? (
//                         platter.foodItems.map((foodItem) => (
//                           <li key={foodItem._id} className="text-gray-600">
//                             {foodItem.title} - {foodItem.price} Taka
//                           </li>
//                         ))
//                       ) : (
//                         <li className="text-gray-500">
//                           No food items in this platter.
//                         </li>
//                       )}
//                     </ul>
//                   </li>
//                 ))
//               ) : (
//                 <li className="text-gray-500">
//                   No custom platters in this order.
//                 </li>
//               )}
//             </ul>

//             <button
//               onClick={() => handleDelete(order._id)}
//               className="mt-4 bg-red-500 text-white py-2 px-4 rounded"
//             >
//               Delete Order
//             </button>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Order;

import React, { useState, useEffect } from "react";
import axios from "axios";

const Order = () => {
  const [orders, setOrders] = useState([]); // State to store orders

  // Fetch orders from the API
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await axios.get(
          "https://ekhoni-khabo-server.vercel.app/api/v1/order/all-orders" // Use the correct endpoint
          // "http://localhost:8081/api/v1/order/all-orders" // Use the correct endpoint
        );
        console.log("API Response:", response.data); // Log the response
        setOrders(response.data.orders); // Set the orders array from the response
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };
    fetchOrders();
  }, []);

  // Handle delete order
  const handleDelete = async (orderId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this order?"
    );
    if (!confirmDelete) return;

    try {
      const token = localStorage.getItem("authToken");
      await axios.delete(
        `https://ekhoni-khabo-server.vercel.app/api/v1/order/delete-order/${orderId}`, // Use the correct endpoint
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // Remove the deleted order from the UI
      setOrders(orders.filter((order) => order._id !== orderId));
    } catch (error) {
      console.error("Error deleting order:", error);
    }
  };

  return (
    <div className="flex flex-col items-center">
      <h1 className="text-[30px] font-bold p-4">Orders List</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pl-64">
        {orders.map((order) => (
          <div key={order._id} className="bg-white shadow-md rounded-lg p-4">
            <h3 className="text-xl font-semibold">Order ID: {order.orderId}</h3>
            <p className="text-gray-600">Name: {order.name}</p>
            <p className="text-gray-600">Address: {order.address}</p>
            <p className="text-gray-600">Phone: {order.phone}</p>
            <p className="text-gray-600">Email: {order.email}</p>
            <p className="text-gray-600">Request: {order.request}</p>
            <p className="text-gray-600">
              Created At: {new Date(order.createdAt).toLocaleString()}
            </p>

            {/* Displaying related items */}
            <h4 className="text-lg font-semibold mt-3">Items:</h4>
            <ul className="list-disc ml-4">
              {order.items && order.items.length > 0 ? (
                order.items.map((item) => (
                  <li key={item._id} className="text-gray-700">
                    {item.title} - {item.price} Taka
                  </li>
                ))
              ) : (
                <li className="text-gray-500">
                  No regular items in this order.
                </li>
              )}
            </ul>

            {/* Displaying custom platters and their food items */}
            <h4 className="text-lg font-semibold mt-3">Custom Platters:</h4>
            <ul className="list-disc ml-4">
              {order.customPlatters && order.customPlatters.length > 0 ? (
                order.customPlatters.map((platter) => (
                  <li key={platter._id} className="text-gray-700">
                    <strong>{platter.platterType}</strong>
                    <ul className="list-disc ml-4">
                      {platter.foodItems && platter.foodItems.length > 0 ? (
                        platter.foodItems.map((foodItem) => (
                          <li key={foodItem._id} className="text-gray-600">
                            {foodItem.title} - {foodItem.price} Taka
                          </li>
                        ))
                      ) : (
                        <li className="text-gray-500">
                          No food items in this platter.
                        </li>
                      )}
                    </ul>
                  </li>
                ))
              ) : (
                <li className="text-gray-500">
                  No custom platters in this order.
                </li>
              )}
            </ul>

            <button
              onClick={() => handleDelete(order._id)}
              className="mt-4 bg-red-500 text-white py-2 px-4 rounded"
            >
              Delete Order
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Order;
